import BaseService from "../BaseService";
import _ from "lodash";

class LoyaltyPoinSettinService extends BaseService {
    getLoyaltyPoint = async () => {
        var data = await this._api.get("/loyalty_point_setting/getpointsetting");
        return data;
    };
    saveLoyaltyPoint = async (setting) => {
        var data = await this._api.post("/loyalty_point_setting/savepointsetting", setting);
        return data;
    };

    adjustPoints = async ({ customer_id, point, direction, reason }) => {
        var data = await this._api.post("/loyalty_point/adjust", {
            customer_id,
            point,
            direction,
            reason,
        });
        return data;
    };

  


}
export default LoyaltyPoinSettinService;
